(function(){
  function init(section){
    if(section.dataset.similarReady)return;
    var track=section.querySelector('[data-similar-track]');
    if(!track)return;
    section.dataset.similarReady='true';
    var dots=section.querySelector('[data-similar-dots]');
    var arrows=section.querySelector('.similar-products__arrows');
    var prev=section.querySelector('[data-similar-prev]');
    var next=section.querySelector('[data-similar-next]');
    var pages=1;
    function columns(){return matchMedia('(max-width: 989px)').matches?2:4}
    function width(){
      var card=track.querySelector('.product-card');
      var gap=parseFloat(getComputedStyle(track).gap)||0;
      return card?(card.getBoundingClientRect().width+gap)*columns():track.clientWidth;
    }
    function current(){return Math.min(pages-1,Math.round(track.scrollLeft/width()))}
    function update(){
      var page=current();
      dots.querySelectorAll('button').forEach(function(dot,i){dot.setAttribute('aria-current',i===page?'true':'false')});
      prev.disabled=page===0;
      next.disabled=page>=pages-1;
    }
    function build(){
      pages=Math.max(1,Math.ceil(track.querySelectorAll('.product-card').length/(columns()*2)));
      dots.innerHTML='';
      for(var i=0;i<pages;i++){
        var dot=document.createElement('button');
        dot.type='button';
        dot.dataset.page=i;
        dot.setAttribute('aria-label',(document.documentElement.lang==='ar'?'الصفحة ':'Page ')+(i+1));
        dots.appendChild(dot);
      }
      dots.hidden=pages===1;
      arrows.hidden=pages===1;
      update();
    }
    function go(page){
      var destination=Math.max(0,Math.min(page*width(),track.scrollWidth-track.clientWidth));
      track.scrollTo({left:destination,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    prev.addEventListener('click',function(){go(current()-1)});
    next.addEventListener('click',function(){go(current()+1)});
    dots.addEventListener('click',function(event){var dot=event.target.closest('button[data-page]');if(dot)go(Number(dot.dataset.page))});
    track.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',build);
    build();
  }
  function start(){document.querySelectorAll('[data-similar-products]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('[data-similar-products]').forEach(init)});
})();